export default __webpack_public_path__ + "static/media/joe.25958001.jpg";